import { Menu, MenuItem, Tooltip } from "@mui/material";
import { trackMenuStyles } from "./styles";
import { handleAddTrackVersion } from "../TrackComponents/TrackHandler/trackHandlers";
import { addNewVersion } from "../TrackComponents/TrackHandler/trackHandlers";
import { downloadSong } from "../TrackComponents/TrackHandler/trackHandlers";
import { addDolbyEffect } from "../TrackComponents/TrackHandler/trackHandlers";
import { TrackMenuProps } from "./types";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { useContext, useState } from "react";
// import { TrackAddFileModal } from "../Modal/TrackAddFileModal";
import { CustomIconButton } from "../../pages/Tracks/styles";
import { THEME } from "../../theme";
import { MasterModal } from "../MasteringComponents/MasterModal";
import { AuthContext, UserDetailsContext } from "../../contexts";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { SplitSheet } from "../Modal/SplitSheet";
import {
  IncrementEnterpriseMasteringCountResponse,
  SubscriptionTier,
} from "../../proto/api_pb";
import { incrementMasteringCount } from "../../services/masteringService";

export const TrackMenu: React.FC<TrackMenuProps> = ({
  track,
  handleOpenCollabsModal,
  handleOpenEditTrackModal,
  handleOpenSelectDeleteModal,
  handleRefreshTracks,
  handleOpenUpdateSubModal,
}) => {
  const [isMasterModalOpen, setIsMasterModalOpen] = useState<boolean>(false);
  const [previewLoading, setPreviewLoading] = useState<boolean>(false);
  const [state, setState] = useState<string>("Uploading track...");
  const [selectedPreset, setSelectedPreset] = useState("Bubbly");
  const [selectedPresetVal, setSelectedPresetVal] = useState("a");
  const [sliderValue, setSliderValue] = useState(-14);
  const [jobId, setJobId] = useState<string | undefined>(undefined);
  const { userId } = useContext(AuthContext);
  const [masteredMusicUrl, setMasteredMusicUrl] = useState<string | undefined>(
    undefined
  );
  const [previewUrl, setPreviewUrl] = useState<Map<string, string> | undefined>(
    undefined
  );
  const [previewState, setPreviewState] =
    useState<string>("Uploading track...");
  const [trackMenuAnchorEl, setTrackMenuAnchorEl] =
    useState<null | HTMLElement>(null);
  const { isEnterpriseAccount, enterprise, subscriptionTier } =
    useContext(UserDetailsContext);
  const openTrackMenu = Boolean(trackMenuAnchorEl);
  const handleTrackMenuClose = () => {
    setTrackMenuAnchorEl(null);
  };
  const handleOpenTrackMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setTrackMenuAnchorEl(event.currentTarget);
  };
  const { getValidAccessToken } = useGetValidAccessToken();

  const getDolbyEffect = async (
    selectedPresetArray: string[],
    sliderValue: number,
    trackUrl: string,
    trackVersionId: string,
    previewStartValue: number | undefined,
    duration: number | undefined
  ) => {
    const accessToken = await getValidAccessToken();
    addDolbyEffect(
      selectedPresetArray,
      sliderValue,
      accessToken,
      trackUrl,
      trackVersionId,
      setPreviewUrl,
      setPreviewLoading,
      handlePreviewState,
      previewStartValue,
      duration
    );
  };

  const handleState = (state: string) => {
    setState(`${state}`);
  };

  const processTrackVersion = async (
    sliderValue: number,
    selectedPresetValue: string,
    trackUrl: string,
    trackVersionId: string,
    isFree?: boolean
  ) => {
    try {
      const token = await getValidAccessToken();
      handleAddTrackVersion(
        selectedPresetValue,
        sliderValue,
        token,
        trackUrl,
        trackVersionId,
        setMasteredMusicUrl,
        setPreviewLoading,
        handleState,
        setJobId,
        isFree
      );
      setSliderValue(sliderValue);
      setSelectedPresetVal(selectedPresetValue);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePreviewState = (state: string) => {
    setPreviewState(`${state}`);
  };

  const handleMasteringOnMenuClicked = () => {
    if (
      subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_FREE &&
      !isEnterpriseAccount
    ) {
      handleOpenUpdateSubModal();
    } else {
      handleMasterModalOpen();
    }
  };
  const handleMasterModalOpen = () => {
    setIsMasterModalOpen(true);
  };
  const handleMasterModalClose = () => setIsMasterModalOpen(false);

  const createNewVersion = async () => {
    try {
      const token = await getValidAccessToken();
      if (track.track) {
        console.log(`selectedPreset: ${selectedPreset}`);
        console.log(`map: ${previewUrl}`);
        await addNewVersion(
          track.track,
          masteredMusicUrl,
          selectedPreset,
          jobId,
          previewUrl?.get(selectedPresetVal),
          token,
          track.track?.getId(),
          userId,
          handleRefreshTracks,
          sliderValue,
          isEnterpriseAccount ? enterprise?.id : undefined
        );
        if (enterprise?.id) {
          const res = await incrementMasteringCount(
            token,
            enterprise?.id,
            userId
          );
          if (res instanceof IncrementEnterpriseMasteringCountResponse) {
            console.log("Mastering Count Incremented");
          }
        }
      }
    } catch (error) {
      console.log(`New Version After Mastering Error: ${error}`);
    } finally {
      handleMasterModalClose();
    }
  };
  return (
    <>
      <Tooltip title="More" placement="top">
        <CustomIconButton
          aria-controls={openTrackMenu ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={openTrackMenu ? "true" : undefined}
          onClick={(e) => handleOpenTrackMenu(e)}
        >
          <img
            style={{
              filter: THEME === "light" ? "invert(100%)" : "contrast(300%)",
              width: "17px",
              height: "17px",
            }}
            src="/assets/icons/TracksPageIcons/dots-vertical.svg"
            alt="icon"
          />
        </CustomIconButton>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={trackMenuAnchorEl}
        open={openTrackMenu}
        onClose={handleTrackMenuClose}
        PaperProps={{
          style: trackMenuStyles.paperProps,
        }}
        sx={trackMenuStyles.menu}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem
          onClick={async () => {
            await downloadSong(
              track.trackUrl,
              track.track?.getTitle(),
              "",
              "",
              ""
            );
            handleTrackMenuClose();
          }}
        >
          <img
            style={{
              margin: "2px",
              marginRight: "8px",
              filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
            }}
            src="/assets/icons/TracksPageIcons/download-01.svg"
            alt=""
          />
          Download
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleTrackMenuClose();
            handleOpenEditTrackModal && handleOpenEditTrackModal(track);
          }}
        >
          <img
            style={{
              margin: "2px",
              marginRight: "8px",
              filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
            }}
            src="/assets/icons/TracksPageIcons/edit-05.svg"
            alt=""
          />
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleTrackMenuClose();
            handleOpenSelectDeleteModal && handleOpenSelectDeleteModal(track);
          }}
        >
          <DeleteOutlinedIcon
            style={{
              margin: "2px",
              marginRight: "8px",
              filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
            }}
          />
          Delete
        </MenuItem>
        <MenuItem onClick={handleMasteringOnMenuClicked}>
          <img
            style={{
              margin: "2px",
              marginRight: "8px",
              filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
            }}
            src="/assets/icons/TracksPageIcons/dolby.svg"
            alt=""
          />
          Dolby Mastering
        </MenuItem>
        {track.track && isMasterModalOpen && (
          <MasterModal
            isMasterModalOpen={isMasterModalOpen}
            handleMasterModalOpen={handleMasterModalOpen}
            handleMasterModalClose={handleMasterModalClose}
            track={track}
            addDolbyEffect={getDolbyEffect}
            masteredMusicUrl={masteredMusicUrl}
            handleAddTrackVersion={processTrackVersion}
            state={state}
            previewState={previewState}
            previewLoading={previewLoading}
            setPreviewLoading={setPreviewLoading}
            previewUrl={previewUrl}
            addNewVersion={createNewVersion}
            trackUrl={track.trackUrl}
            trackVersionId={track.track?.getTrackVersionId()}
            setSelectedPreset={setSelectedPreset}
          />
        )}
        <MenuItem
          onClick={() => {
            handleTrackMenuClose();
            handleOpenCollabsModal && handleOpenCollabsModal(track);
          }}
        >
          <img
            style={{
              margin: "2px",
              marginRight: "8px",
              filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
            }}
            src="/assets/icons/TracksPageIcons/users-plus.svg"
            alt=""
          />
          Edit Collaborators
        </MenuItem>
        {isEnterpriseAccount && (
          <SplitSheet
            handleTrackMenuClose={handleTrackMenuClose}
            track={track}
            isPublishingSplitSheetDetails={false}
          />
        )}
        {isEnterpriseAccount && (
          <SplitSheet
            handleTrackMenuClose={handleTrackMenuClose}
            track={track}
            isPublishingSplitSheetDetails={true}
          />
        )}
      </Menu>
    </>
  );
};
